import React, { useEffect } from 'react';
import URL from 'utils/URL';
import img404 from './images/404.jpg';
import './style.scss';

interface Page404Props {
    autoRedirect?: boolean;
}

const Page404: React.FC<Page404Props> = ({ autoRedirect }) => {
    useEffect(() => {
        if (autoRedirect) {
            window.location.replace(
                URL.merge(window.location.href, {
                    pathname: '/login',
                    query: {
                        ...(window.location.pathname.startsWith('/logout')
                            ? {}
                            : {
                                  next: window.location.href
                              })
                    }
                })
            );
        }
    }, [autoRedirect]);

    return autoRedirect ? null : (
        <div className="page-404">
            <div className="site-main">
                <img className="tip-img" src={img404} alt="404" />
            </div>
        </div>
    );
};

export default Page404;
